export default __webpack_public_path__ + "static/media/DetectiveWhite.de4683b5.png";